<template>
  <div style="display: flex; justify-content: space-between; align-content: space-between;">
    <div style="width: 15%;"></div>

    <el-input v-model="query" :placeholder="KT('device.search')" style="--el-input-border-radius: 5px; margin-right: 5px; font-size: 10px;"></el-input>

    <el-button
      v-if="store.getters.advancedPermissions(49)"
      @mouseleave="hideTip"
      @mouseenter.stop="showTip($event, KT('group.add'))"
      type="primary"
      @click="editGroupRef.newGroup()"
      plain
    >
      <i class="fas fa-folder-plus"></i>
    </el-button>

    <el-button
      @mouseleave="hideTip"
      @mouseenter.stop="showTip($event, KT('device.add'))"
      :disabled="!store.getters['checkDeviceLimit']"
      v-if="store.getters.advancedPermissions(13) && (store.state.auth.deviceLimit === -1 || store.state.auth.deviceLimit > 0)"
      type="primary"
      @click="(store.getters['checkDeviceLimit']) ? editDeviceRef.newDevice() : deviceLimitExceded()">
      <i class="fas fa-plus"></i>
    </el-button>
   
    

                <div class="modal-container" v-if="isShowModal">
                  <div class="modal">
                    <div class="modal-header">
                      <div class="flex items-center text-lg">Informes Sobre Dispositivos</div>
                      <button aria-label="close" @click="closeModal" class="close-button">
                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" fill-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div style="display: flex; flex-direction: column; gap: 5px; align-items: flex-start;">
                        <el-button class="custom-button" size="small" @click="generatePDF">Dispositivos Activos (PDF)</el-button>
                        <el-button class="custom-button" size="small" @click="generateOfflinePDF">Dispositivos OFFline (PDF)</el-button>
                        <el-button class="custom-button" size="small" @click="filterLastHour">Última Hora</el-button>
                        <el-button class="custom-button" size="small" @click="generateExcel">Dispositivos Activos (Excel)</el-button>
                        <el-button class="custom-button" size="small" @click="generateOfflineExcel">Dispositivos OFFline (Excel)</el-button>
                        <el-button class="custom-button" size="small" @click="generateJSON">Dispositivos Activos (JSON)</el-button>
                        <el-button class="custom-button" size="small" @click="generateOfflineJSON">Dispositivos OFFline (JSON)</el-button>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div class="flex justify-end w-full">
                        <button class="decline-button" @click="closeModal">Salir</button>
                      
                      </div>
                    </div>
                  </div>
    </div>
  </div>











  <div style="border: silver 1px solid; border-radius: 5px; margin-top: 10px; margin-bottom: 5px; height: calc(95vh - 200);">
    <div class="deviceHead">
      <div @click="store.dispatch('devices/setSorting', 'name')" class="name" style="font-size: 12px; box-sizing: border-box; font-weight: 100; padding: 5px; flex: 1;">
        {{ KT('device.name') }}
        <span v-if="store.getters['devices/sorting'] === 'name-asc'">
          <i class="fas fa-sort-alpha-down"></i>
        </span>
        <span v-else-if="store.getters['devices/sorting'] === 'name-desc'">
          <i class="fas fa-sort-alpha-up"></i>
        </span>
        <span v-else>
          <i style="color: silver;" class="fas fa-sort-alpha-down"></i>
        </span>
      </div>
      <div @click="store.dispatch('devices/setSorting', 'status')" class="name" style="font-size: 12px; box-sizing: border-box; font-weight: 100; padding: 5px; width: 32px;">
        <span v-if="store.getters['devices/sorting'] === 'status-asc'">
          <i class="fas fa-sort-alpha-down"></i>
        </span>
        <span v-else-if="store.getters['devices/sorting'] === 'status-desc'">
          <i class="fas fa-sort-alpha-up"></i>
        </span>
        <span v-else>
          <i style="color: silver;" class="fas fa-sort-alpha-down"></i>
        </span>
      </div>
      <div @click="store.dispatch('devices/setSorting', 'lastUpdate')" class="name" style="font-size: 12px; box-sizing: border-box; font-weight: 100; padding: 5px; width: 90px; text-align: center;">
        {{ KT('device.updated') }}
        <span v-if="store.getters['devices/sorting'] === 'lastUpdate-asc'">
          <i class="fas fa-sort-alpha-down"></i>
        </span>
        <span v-else-if="store.getters['devices/sorting'] === 'lastUpdate-desc'">
          <i class="fas fa-sort-alpha-up"></i>
        </span>
        <span v-else>
          <i style="color: silver;" class="fas fa-sort-alpha-down"></i>
        </span>
      </div>
      <div class="icons" @click="setSortingByState()" style="flex: none; width: 183px !important; font-size: 12px; box-sizing: border-box; font-weight: 100; padding: 5px; text-align: center;">
        {{ KT('sorting.' + store.getters['devices/sorting']) }}
        <span><i class="fas fa-sort"></i></span>
      </div>
    </div>

    <div ref="realDevices" @scroll="realScroll($event)" style="overflow-x: hidden; overflow-y: scroll; height: calc(100vh - 230px);">
      <div class="fakeScroll" :style="{ height: (filteredDevices.length * 33) + 'px' }">
        <div v-for="(group) in groupedDevices" :key="group.id">
          <div v-if="group.id !== -1" @click="store.dispatch('setGroupPref', group.id)" style="background: #f7f7f7; padding: 5px; padding-left: 8px; cursor: pointer; font-size: 13px;">
            <span v-if="store.getters.groupPref(group.id)">
              <i class="fas fa-angle-up"></i>
            </span>
            <span v-else>
              <i class="fas fa-angle-down"></i>
            </span>
            &nbsp;&nbsp;&nbsp;{{ group.name }}
          </div>

          <div v-if="group.id == -1 || store.getters.groupPref(group.id)">
            <div v-for="(device) in group.devices" :key="device.id" class="device" :class="{'isDisabled': device.disabled}" @click="markerClick(device.id)" @contextmenu.prevent="markerContext($event, device.id)" :set="position = store.getters['devices/getPosition'](device.id)">
              <div class="name" style="flex: 1;">{{ device.name }}</div>
              <div class="name" style="width: 32px; overflow: hidden; text-align: center; font-size: 18px; box-sizing: border-box; overflow: hidden;">
                <div @mouseleave="hideTip" @mouseenter.stop="showTip($event, device.disabled ? KT('disabled') : device.lastUpdate === null ? KT('new') : device.status === 'online' ? KT('online') : (device.status === 'offline') ? KT('offline') : KT('unknown'))">
                  <span v-if="device.lastUpdate === null"><i style="color: var(--el-color-info);" class="fas fa-question-circle"></i></span>
                  <span v-else-if="device.status === 'online'"><i style="color: var(--el-color-success);" class="fas fa-check-circle"></i></span>
                  <span v-else-if="device.status === 'offline'"><i style="color: var(--el-color-danger);" class="fas fa-exclamation-circle"></i></span>
                  <span v-else><i class="fas fa-question-circle" style="color: var(--el-color-warning);"></i></span>
                </div>
              </div>
              <div class="name" style="width: 90px; box-sizing: border-box; overflow: hidden; white-space: nowrap; text-align: center;">{{ getLastUpdated(device.lastUpdate, now) }}</div>
              <div v-if="position" class="icons" style="width: 178px !important; flex: none;">
               


                <div v-if="position.attributes.alarm"
                    @mouseleave="hideTip" @mouseenter.stop="showAlarmTip($event,device.id)"
                    :style="{color: 'var(--el-color-danger)'}"><i class="fas fa-exclamation-triangle"></i></div>

                <div v-else
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('alarms.none'))" :style="{color: 'var(--el-color-info)'}"><i class="fas fa-exclamation-triangle"></i></div>


              <div
                  v-if="position.attributes['driverUniqueId']"
                  @mouseleave="hideTip" @mouseenter.stop="showDriverTip($event,device.id)"
                  :style="{color: 'var(--el-color-success)'}"><i class="far fa-id-card"></i></div>

              <div
                  v-else-if="position.attributes['isQrLocked'] && position.attributes['isQrLocked']==true"
                  @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.noDriverLocked'))"
                  :style="{color: 'var(--el-color-danger)'}"><i class="far fa-id-card"></i></div>

              <div
                  v-else
                  @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.noDriver'))"
                  :style="{color: 'var(--el-color-info)'}"><i class="far fa-id-card"></i></div>






                <div
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.ignitionOn'))"
                    v-if="position.attributes.ignition===true" :style="{color: 'var(--el-color-success)'}"><i class="fas fa-key"></i></div>

                <div
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.ignitionOff'))"
                    v-else-if="position.attributes.ignition===false" :style="{color: 'var(--el-color-danger)'}"><i class="fas fa-key"></i></div>

                <div
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('unknown'))"
                    v-else :style="{color: 'var(--el-color-info)'}"><i class="fas fa-key"></i></div>



                <div
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.blocked'))"
                    v-if="position.attributes.blocked===true" :style="{color: 'var(--el-color-danger)'}"><i class="fas fa-lock"></i></div>

                <div
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.unblocked'))"
                    v-else-if="position.attributes.blocked===false"  :style="{color: 'var(--el-color-success)'}"><i class="fas fa-lock-open"></i></div>

                <div
                    v-else
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('unknown'))"
                    :style="{color: 'var(--el-color-info)'}"><i class="fas fa-lock-open"></i></div>

              <template v-if="store.state.server.isPlus && store.getters.advancedPermissions(9)">
                <div
                    v-if="store.getters['geofences/isAnchored'](device.id)"
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.anchorEnabled'))"
                    :style="{color: 'var(--el-color-warning)'}"><i class="fas fa-anchor"></i></div>

                <div
                    v-else
                    @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.anchorDisabled'))"
                    :style="{color: 'var(--el-color-info)'}"><i class="fas fa-anchor"></i></div>
              </template>




              <div
                  v-if="position.attributes.motion"
                  @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.moving'))"
                  :style="{color: 'var(--el-color-primary)'}"><i class="fas fa-angle-double-right"></i></div>

              <div
                  v-else-if="position.attributes.stoppedTime"
                  @mouseleave="hideTip" @mouseenter.stop="showStopped($event,device.id)"
                  :style="{color: 'var(--el-color-info)'}"><i class="fas fa-angle-double-right"></i></div>
              <div
                  v-else
                  @mouseleave="hideTip" @mouseenter.stop="showTip($event,KT('device.stoped'))"
                  :style="{color: 'var(--el-color-info)'}"><i class="fas fa-angle-double-right"></i></div>




                </div>
                <div v-else class="icons" style="flex: none; width: 178px !important;">
                  <div style="color: var(--el-text-color-disabled-base)">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" style="opacity: 0.3" height="15px" viewBox="0 0 640 512">
                        <path d="M154 95.42C187.3 38.35 249.2 0 320 0C426 0 512 85.96 512 192C512 230.7 489 282.8 459 334.5L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L154 95.42zM257.8 176.8L349.6 248.7C370.1 238 384 216.7 384 192C384 156.7 355.3 128 320 128C289.9 128 264.7 148.8 257.8 176.8zM296.3 499.2C245.9 436.2 132.3 285.2 128.1 196.9L406.2 416.1C382.7 449.5 359.9 478.9 343.7 499.2C331.4 514.5 308.6 514.5 296.3 499.2V499.2z"/>
                      </svg>
                    </i> <span>{{ KT('device.noPosition') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>

    <el-button type="primary" @click="showModal">Informes</el-button>
  </template>
  

<script setup>



import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'
import 'element-plus/es/components/notification/style/css'

import {ElButton,ElInput} from "element-plus";

import {ref,computed,inject,onMounted,watch} from 'vue';
import {useStore} from "vuex"

import KT from '../tarkan/func/kt.js';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';
const store = useStore();

const markerContext = inject('markerContext');
const markerClick = inject('markerClick');

const filteredDevices = ref([]);

const query = ref(window.localStorage.getItem('query') || '');
const editDeviceRef = inject('edit-device');
const editGroupRef = inject('edit-group');

const now = ref(0);


const deviceLimitExceded = ()=>{

}

const showTip = (evt,text)=>{
  window.$showTip(evt,text);
}

const hideTip = (evt,text)=>{
  window.$hideTip(evt,text);
}

const showAlarmTip = ($event,deviceId)=>{
  const position = store.getters['devices/getPosition'](deviceId);
  showTip($event,KT('alarms.'+position.attributes.alarm))
}


const showStopped = ($event,deviceId)=>{

  const position = store.getters['devices/getPosition'](deviceId);

  showTip($event,'Parado há '+getLastUpdated(position.attributes.stoppedTime,now.value))
}

const showDriverTip = ($event,deviceId)=>{
  const position = store.getters['devices/getPosition'](deviceId);

  if(position.attributes['driverUniqueId']){
    const driver = store.getters['drivers/getDriverByUniqueId'](position.attributes['driverUniqueId']);
    if(driver){
      showTip($event,driver.name)
    }else{
      showTip($event,position.attributes['driverUniqueId'])
    }
  }

}

const realDevices = ref(null);
const offsetDevices = ref(0);
const maxDevices = ref(0);

const validStates = [
    'motion',
    'anchor',
    'locked',
    'ignition',
    'driver',
    'alert'
]

const setSortingByState = ()=>{

    const tmp = store.getters['devices/sorting'].split("-");

    if(tmp[0]==='state') {
      let idx = validStates.findIndex((i)=> i===tmp[1])+1;
      if(idx>(validStates.length-1)){
        store.dispatch("devices/setSorting","name");
      }else {
        store.dispatch('devices/setSortingState', 'state-' + validStates[idx]);
      }
    }else{
      store.dispatch('devices/setSortingState','state-motion');
    }
}

onMounted(()=>{

  const real = realDevices.value;

  maxDevices.value = Math.floor(real.clientHeight / 33)+3;
  offsetDevices.value = Math.floor(real.scrollTop / 33);
  setInterval(()=>{
    now.value = new Date();
  },3000);

  filteredDevices.value = recalcDevices();
});

watch(query,()=>{
  filteredDevices.value = recalcDevices();
});

watch(()=> store.getters['devices/getOrderedDevices'].length,()=>{
  filteredDevices.value = recalcDevices();
});


watch(()=> store.getters['devices/sorting'],()=>{
  filteredDevices.value = recalcDevices();
});

const realScroll = (event)=>{
  const real = event.target;


  maxDevices.value = Math.floor(real.clientHeight / 33)+3;
  offsetDevices.value = Math.floor(real.scrollTop / 33);

}




const getLastUpdated = (t,tt)=>{
  tt = new Date();

  if(t===null){
    return KT('new');
  }

  const diff = Math.round((new Date(tt).getTime() - new Date(t).getTime())/1000);

  if(diff<0){
    return KT('now');
  }else if(diff>86400){
    const dias = Math.round(diff/86400);

    return dias+' '+KT('days');
  }else if(diff>3600){
    const horas = Math.round(diff/3600);

    return horas+' '+KT('hours');
  }else if(diff>60){
    const minutos = Math.round(diff/60);

    return minutos+' '+KT('minutes');
  }else{
    return KT('lessMinute');
  }

}


const recalcDevices = ()=>{
  console.log("Gargalo 3");

  window.localStorage.setItem('query',query.value);

  const r = query.value.toLowerCase().matchAll(/(.*?):(?<sinal>\+|-|=)(?<tempo>\d*) (?<filtro>dias|minutos|horas|segundos)/gi)
  const s = r.next();

  let groupList = [];

  store.state.groups.groupList.forEach((g)=>{
      if(String(g.name).toLowerCase().match(query.value.toLowerCase())){
        groupList.push(g.id);
      }
  });

  console.log(groupList);

  let tmp = [];

  store.getters['devices/getOrderedDevices'].forEach((dk) => {

    const d = store.getters['devices/getDevice'](dk);
    let visible = false;

    d.icon.remove();

    if(s.value){

      if(s.value.groups.filtro==='dias'){
        const df = parseInt(s.value.groups.tempo)*86400;
        const diff = Math.round((new Date().getTime() - new Date(d.lastUpdate).getTime())/1000);


        console.log(df);
        console.log(diff);

        if(s.value.groups.sinal==='+' && diff>=df){
          d.icon.addToMap();

          visible = true;

        }else if(s.value.groups.sinal==='-' && diff<=df){
          d.icon.addToMap();
          visible = true;
        }else if(s.value.groups.sinal==='='){


          console.log("NO")
        }
      }
    }


    for(let k of Object.keys(d)){
      if(k==='status' && String(d[k]).toLowerCase().replace('unknown','desconhecido').match(query.value.toLowerCase())){

        d.icon.addToMap();
        visible = true;
      }else if(String(d[k]).toLowerCase().match(query.value.toLowerCase())){

        d.icon.addToMap();
        visible = true;
      }
    }



    for(let k of Object.keys(d.attributes)){



      if(d.attributes[k] && d.attributes[k].toString().toLowerCase().match(query.value.toLowerCase())){
        d.icon.addToMap();
        visible = true;
      }
    }

    if(!visible && d.groupId!==0 && groupList.includes(d.groupId)){
      d.icon.addToMap();
      visible = true;
    }


    if(visible){
      tmp.push(d);
    }

  });

  return tmp;
}



const chunkedDevices = computed(()=>{
  let tmp = Object.assign([],filteredDevices.value);




  return tmp.splice(0,maxDevices.value+offsetDevices.value);
});

const groupedDevices = computed(()=>{
  let showGroups = store.getters['mapPref']('groups');

  if(showGroups){


    let tmp = {};
    const groups = store.state.groups.groupList;

    filteredDevices.value.forEach((device)=>{

        if(!groups.find((g)=> g.id===device.groupId )){
          if (!tmp[0]) {
            tmp[0] = [];
          }
          tmp[0].push(device);
        }else {

          if (!tmp[device.groupId]) {
            tmp[device.groupId] = [];
          }
          tmp[device.groupId].push(device);
        }
    })

    let list = [];

    list.push({id: 0,name: 'Sem Grupo',devices: tmp[0],open: true});
    groups.forEach((g)=>{
      if(tmp[g.id] && tmp[g.id].length>0) {
        list.push({id: g.id, name: g.name, devices: tmp[g.id],open: false});
      }
    })

    return list;
  }else{
    return [{id: -1,name: '',devices: chunkedDevices.value,open: true}];
  }

})

const generatePDF = () => {
  const doc = new jsPDF('landscape', 'mm', 'a4'); // Configurar A4 apaisado
  doc.setFontSize(5); // Tamaño de fuente reducido
  
  const baseUrl = window.location.origin; // Obtener el dominio base de la app
  
  // Ruta relativa del logo
  const logoPath = '/tarkan/assets/custom/logo.png';
  
  // Construir la URL completa del logo
  const logoUrl = baseUrl + logoPath;
  
  // Añadir el logo en la posición deseada (ajustado a 2x1 cm)
  doc.addImage(logoUrl, 'PNG', 10, 10, 20, 5); // El logo tiene un tamaño de 2 cm x 1 cm
  
  // Título
  //doc.setFontSize(10); // Tamaño de fuente para el título
  doc.text("Reporte de Dispositivos Activos", 10, 25); // Título debajo del logo
  
  // Definición de columnas
  const columns = ["Unique ID", "Placa", "Nome", "Teléfono", "Operador", "ICCID", "Contacto", "Categoría", "Deshabilitado"];
  
  // Cabecera de la tabla
  doc.setFillColor(200, 200, 200); // Color de fondo para la cabecera
  doc.rect(10, 35, 280, 6, 'F'); // Ajustar altura de la cabecera (6 mm de alto)
  
  // Establecer color del texto
  doc.setTextColor(0);
  
  // Colocar los títulos de las columnas
  columns.forEach((col, index) => {
    doc.text(col, 12 + (index * 30), 40); // Ajustar posición por columna (y = 40 para que se vea bien)
  });
  
  // Posición inicial para las filas de la tabla
  let y = 45; // Inicializar posición Y
  let alternateColor = true;
  
  // Preparar los datos (esto debe ser adaptado según cómo recibes los datos)
  const usersData = filteredDevices.value.map(device => [
    device.uniqueId || '-',
    device.attributes?.placa || '-',
    device.name || '-',
    device.phone || '-',
    device.attributes?.operator || '-',
    device.attributes?.iccid || '-',
    device.contact || '-',
    device.category || '-',
    device.disabled ? 'Sí' : 'No'
  ]);
  
  // Ordenar dispositivos por última actualización (esto depende de tu estructura)
  const sortedDevices = [...usersData].sort((a, b) => {
    return new Date(b.lastUpdate) - new Date(a.lastUpdate); // Cambiar según la estructura de usersData
  });
  
  // Añadir los datos de cada dispositivo
  sortedDevices.forEach((data) => {
    // Color de fondo para renglones alternos
    doc.setFillColor(alternateColor ? 240 : 255, alternateColor ? 240 : 255, alternateColor ? 240 : 255);
    
    // Dibujar un rectángulo para cada fila (altura de cada fila: 6 mm)
    doc.rect(10, y, 280, 6, 'F'); 
  
    // Colocar el texto en cada celda
    data.forEach((cell, index) => {
      doc.text(cell, 12 + (index * 30), y + 4); // Ajustar la posición del texto (4 mm de margen en y)
    });
  
    // Alternar el color de las filas
    alternateColor = !alternateColor;
    
    // Incrementar la posición Y para la siguiente fila
    y += 6; // Ajustar la altura de las filas

    // Añadir una nueva página si es necesario
    if (y >= 195) { // Cambiar este valor si es necesario
      doc.addPage();
      y = 15; // Reiniciar la posición Y
      doc.text("Reporte de Dispositivos Activos", 10, 10);
      doc.rect(10, 15, 280, 6, 'F');
      columns.forEach((col, index) => {
        doc.text(col, 12 + (index * 30), 18); // Ajustar posición según la columna
      });
    }
  });

  // Numerar las páginas
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(5);
    doc.text(`Página ${i} de ${totalPages}`, 280 - 20, 205 ); // Mover 3 cm más abajo
  }

  doc.save("reporte_dispositivos_activos.pdf");
};


const generateExcel = () => {
  // Definir las columnas
  const columns = ["Unique ID", "Placa", "Nome", "Teléfono", "Operador", "ICCID", "Contacto", "Categoría", "Deshabilitado"];

  // Preparar los datos
  const usersData = filteredDevices.value.map(device => [
    device.uniqueId || '-',
    device.attributes?.placa || '-',
    device.name || '-',
    device.phone || '-',
    device.attributes?.operator || '-',
    device.attributes?.iccid || '-',
    device.contact || '-',
    device.category || '-',
    device.disabled ? 'Sí' : 'No'
  ]);

  // Ordenar dispositivos por última actualización
  const sortedDevices = [...usersData].sort((a, b) => {
    return new Date(b.lastUpdate) - new Date(a.lastUpdate); // Cambiar según la estructura de usersData
  });

  // Crear una nueva hoja de trabajo
  const ws = XLSX.utils.aoa_to_sheet([columns, ...sortedDevices]);

  // Crear un nuevo libro de trabajo
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dispositivos Activos");

  // Establecer opciones para la descarga
  XLSX.writeFile(wb, "reporte_dispositivos_activos.xlsx");
};
const generateJSON = () => {
  const usersData = filteredDevices.value.map(device => ({
    uniqueId: device.uniqueId || '-',
    placa: device.attributes?.placa || '-',
    name: device.name || '-',
    phone: device.phone || '-',
    operator: device.attributes?.operator || '-',
    iccid: device.attributes?.iccid || '-',
    contact: device.contact || '-',
    category: device.category || '-',
    disabled: device.disabled ? 'Sí' : 'No'
  }));

  const jsonString = JSON.stringify(usersData, null, 2); // Convertir a JSON con formato
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = 'reporte_dispositivos_activos.json';
  a.click();
  URL.revokeObjectURL(url); // Limpiar el objeto URL
};
// Función para generar PDF de dispositivos fuera de línea

const generateOfflinePDF = () => {
  const doc = new jsPDF('landscape', 'mm', 'a4'); // Configurar A4 apaisado
  doc.setFontSize(5); // Tamaño de fuente reducido

  // Título
  doc.text("Reporte de Dispositivos Fuera de Línea", 10, 10);

  // Definición de columnas
  const columns = ["IMEI", "Placa", "Nombre", "Teléfono", "Operador", "ICCID", "Última Actualización", "Diferencia (Horas)"];
  
  // Cabecera de la tabla
  doc.setFillColor(200, 200, 200);
  doc.rect(10, 15, 280, 6, 'F'); // Ajustar altura de la cabecera
  doc.setTextColor(0);
  columns.forEach((col, index) => {
    doc.text(col, 12 + (index * 35), 18); // Ajustar posición según la columna
  });

  let y = 25; // Inicializar posición Y
  let alternateColor = true;

  const now = new Date();
  
  // Filtrar dispositivos fuera de línea (no actualizados en las últimas 24 horas)
  const offlineDevices = store.getters['devices/getOrderedDevices'].filter(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    const lastUpdate = new Date(device.lastUpdate);
    return (now - lastUpdate) > (24 * 60 * 60 * 1000); // No actualizados en las últimas 24 horas
  });

  // Crear un array de datos para la tabla
  const rows = offlineDevices.map(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    const deviceName = device.name.length > 30 ? device.name.substring(0, 27) + '...' : device.name;

    // Obtener la fecha de la última actualización
    const lastUpdate = new Date(device.lastUpdate);
    const hoursDiff = Math.floor((now - lastUpdate) / (1000 * 60 * 60));

    return [
      device.uniqueId || '-', // Agregar el uniqueId como IMEI
      device.attributes?.placa || '-',
      deviceName,
      device.phone || '-',
      device.attributes?.operator || '-',
      device.attributes?.iccid || '-',
      lastUpdate, // Mantener la fecha como objeto Date para ordenar correctamente
      hoursDiff // Solo dejar la diferencia en horas
    ];
  });

  // Ordenar filas por última actualización (de mayor a menor)
  rows.sort((a, b) => b[6] - a[6]); // Comparar fechas directamente

  // Agregar los datos a la tabla
  rows.forEach((data) => {
    // Color de fondo para renglones alternos
    doc.setFillColor(alternateColor ? 240 : 255);
    doc.rect(10, y, 280, 6, 'F'); // Altura reducida

    // Escribir el texto alineado a la izquierda
    doc.setTextColor(0);
    data.forEach((info, i) => {
      // Formatear la fecha para la columna correspondiente
      if (i === 6) {
        const formattedDate = `${data[6].getDate()}/${data[6].getMonth() + 1}/${data[6].getFullYear()} ${data[6].getHours()}:${data[6].getMinutes().toString().padStart(2, '0')}`;
        doc.text(formattedDate, 12 + (i * 35), y + 4);
      } else {
        doc.text(info.toString(), 12 + (i * 35), y + 4); // Ajustar posición según la columna
      }
    });

    y += 6; // Espacio entre renglones (reducido)
    alternateColor = !alternateColor; // Alterna el color

    // Añadir una nueva página si es necesario
    if (y >= 195) { // Cambiar este valor si es necesario
      doc.addPage();
      y = 15; // Reiniciar la posición Y
      doc.text("Reporte de Dispositivos Fuera de Línea", 10, 10);
      doc.rect(10, 15, 280, 6, 'F');
      columns.forEach((col, index) => {
        doc.text(col, 12 + (index * 35), 18); // Ajustar posición según la columna
      });
    }
  });

  // Numerar las páginas
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(5);
    doc.text(`Página ${i} de ${totalPages}`, 280 - 20, 205); // Mover 3 cm más abajo
  }

  doc.save("reporte_dispositivos_fuera_de_linea.pdf");
};

const generateOfflineExcel = () => {
  const columns = ["IMEI", "Placa", "Nombre", "Teléfono", "Operador", "ICCID", "Última Actualización", "Diferencia (Horas)"];
  const now = new Date();

  // Filtrar dispositivos fuera de línea en las últimas 24 horas
  const offlineDevices = store.getters['devices/getOrderedDevices'].filter(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    const lastUpdate = new Date(device.lastUpdate);
    return (now - lastUpdate) > (24 * 60 * 60 * 1000); // Últimas 24 horas
  });

  // Crear un array de datos para la tabla
  const rows = offlineDevices.map(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    const deviceName = device.name.length > 30 ? device.name.substring(0, 27) + '...' : device.name;

    const lastUpdate = new Date(device.lastUpdate);
    const hoursDiff = Math.floor((now - lastUpdate) / (1000 * 60 * 60));

    return [
      device.uniqueId || '-',
      device.attributes?.placa || '-',
      deviceName,
      device.phone || '-',
      device.attributes?.operator || '-',
      device.attributes?.iccid || '-',
      lastUpdate, // Mantener la fecha como objeto Date
      hoursDiff // Diferencia en horas
    ];
  });

  // Crear una nueva hoja de trabajo
  const ws = XLSX.utils.aoa_to_sheet([columns, ...rows.map(row => {
    return [
      row[0],
      row[1],
      row[2],
      row[3],
      row[4],
      row[5],
      `${row[6].getDate()}/${row[6].getMonth() + 1}/${row[6].getFullYear()} ${row[6].getHours()}:${row[6].getMinutes().toString().padStart(2, '0')}`,
      row[7]
    ];
  })]);

  // Crear un nuevo libro de trabajo
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dispositivos Fuera de Línea");

  // Establecer opciones para la descarga
  XLSX.writeFile(wb, "reporte_dispositivos_fuera_de_linea.xlsx");
};

const generateOfflineJSON = () => {
  const now = new Date();
  const offlineDevices = store.getters['devices/getOrderedDevices'].filter(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    const lastUpdate = new Date(device.lastUpdate);
    return (now - lastUpdate) > (24 * 60 * 60 * 1000); // Últimas 24 horas
  });

  const jsonData = offlineDevices.map(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    return {
      uniqueId: device.uniqueId || '-',
      placa: device.attributes?.placa || '-',
      nombre: device.name || '-',
      telefono: device.phone || '-',
      operador: device.attributes?.operator || '-',
      iccid: device.attributes?.iccid || '-',
      ultimaActualizacion: device.lastUpdate,
      diferenciaHoras: Math.floor((now - new Date(device.lastUpdate)) / (1000 * 60 * 60))
    };
  });

  const jsonString = JSON.stringify(jsonData, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = 'reporte_dispositivos_fuera_de_linea.json';
  a.click();
  URL.revokeObjectURL(url); // Limpiar el objeto URL
};









// Función para filtrar dispositivos por última hora
const filterLastHour = () => {
  const now = new Date();
  const filtered = store.getters['devices/getOrderedDevices'].filter(deviceId => {
    const device = store.getters['devices/getDevice'](deviceId);
    const lastUpdate = new Date(device.lastUpdate);
    return (now - lastUpdate) <= (60 * 60 * 1000); // Última hora
  });

  // Actualizar filteredDevices con la nueva lista
  filteredDevices.value = filtered.map(id => store.getters['devices/getDevice'](id));
  console.log('Dispositivos filtrados según la última hora de conexión.');
};

const isShowModal = ref(false);

function closeModal() {
  isShowModal.value = false;
}

function showModal() {
  isShowModal.value = true;
}






</script>

<style scoped>
.device{
  border-bottom: var(--el-border-color-light) 1px solid;
  display: flex;
  flex-direction: row;
  text-align: center;
  cursor: pointer;
  margin-right: -1px;
}

.deviceHead{
  border-bottom: var(--el-border-color-light) 1px solid;
  display: flex;
  flex-direction: row;
  text-align: center;
  cursor: pointer;
  margin-right: -1px;
  background: var(--el-color-info-light);
}

.device:hover{
  background: var(--el-color-primary-light-9);
}



.device .name,.deviceHead .name{
  font-size: 12px;
  padding: 7px;
  text-align: left;
  line-height: 14px;
  font-weight: 800;
  border-right: var(--el-border-color-light) 1px dotted;
  width: 60%;
}

.icons{
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  flex: 1;
  align-items: center;
  font-size: 11px;
}

.icons div{
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-right: var(--el-border-color-light) 1px dotted;
  font-size: 11px;
}
.icons div i{
  font-size: 14px;
}

.icons div:first-child{
  border-right: none;
}

.icons div span{
  display: flex;
  padding: 2px;
  padding-left: 5px;
}

.subtitle{
  margin-top: 20px;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  color: var(--el-text-color-primary);
}

.subtitle i{
  font-size: 12px;
  margin-right: 3px;
}



  .isDisabled{
    opacity: 0.4;
  }

  .button-container {
    margin-top: 20px;
    display: flex;
    gap: 10px;
  }
  .modal-container {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5); /* Fondo semi-transparente */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal {
    background-color: white;
    border-radius: 8px;
    width: 300px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .modal-header {
    border-bottom: 1px solid #e5e7eb; /* border-gray-200 */
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  
  .modal-body {
    padding: 24px;
  }
  
  .modal-footer {
    padding: 16px;
    border-top: 1px solid #e5e7eb; /* border-gray-200 */
    display: flex;
    justify-content: flex-end;
  }
  
  .decline-button {
    background-color: white;
    border: 1px solid #e5e7eb; /* border-gray-200 */
    border-radius: 8px;
    padding: 8px 16px;
  }
  
  .accept-button {
    background-color: #38a169; /* bg-green-700 */
    color: white;
    border-radius: 8px;
    padding: 8px 16px;
  }
  
  

.custom-button {
  background-color: blue; /* Color de fondo azul */
  color: white; /* Color del texto */
  border: none; /* Eliminar el borde */
  font-size: 14px; /* Tamaño de la fuente */
  border-radius: 4px; /* Radio de las esquinas */
  padding: 15px 4px; /* Aumentar la altura y reducir el ancho */
  width: 200px; /* Ajustar el ancho deseado */
}

.custom-button:hover {
  background-color: darkblue; /* Cambia el color al pasar el mouse */
}





</style>